import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppService } from '../app.service';
import { catchError, concatMap, first } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Store } from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class AjaxService {
	headers: HttpHeaders;
	request_url: any;

	constructor(private http: HttpClient, protected appService: AppService, private store: Store) {
		this.headers = new HttpHeaders({
			'Content-Type': 'application/json',
		});
	}

	get(ms, url, data = null, auth = false, base = false) {
		let str = '';
		if (data) {
			for (let key in data) {
				if (str != '') {
					str += '&';
				}
				str += key + '=' + encodeURIComponent(data[key]);
			}
		}
		return this.init(ms, base, url, auth, str).pipe(
			first(),
			concatMap((v) =>
				this.http.get(v.request_url, { headers: v.headers }).pipe(
					first(),
					catchError((e) => this.handleError(e)),
				),
			),
		);
	}

	post(ms, url, data, auth = false, base = false) {
		return this.init(ms, base, url, auth).pipe(
			first(),
			/* 	tap((value) => {
				console.info('dasd', value);
			}),
			map((resp) => {
				return this._getHttpOptions$().pipe(
					switchMap((customOptions) => {
						console.info('dasda', resp);
						return this.http.post(resp.request_url, data, customOptions);
					}),
					catchError((err: HttpErrorResponse, caught) => {
						throw new Error(err.error.message);
					}),
				);
			}), */
			concatMap((v) =>
				this.http.post(v.request_url, data, { headers: v.headers }).pipe(
					first(),
					catchError((e) => this.handleError(e)),
				),
			),
		);
	}

	update(ms, url, data, auth = false, base = false) {
		return this.init(ms, base, url, auth).pipe(
			first(),
			concatMap((v) =>
				this.http.put(v.request_url, data, { headers: v.headers }).pipe(
					first(),
					catchError((e) => this.handleError(e)),
				),
			),
		);
	}

	destroy(ms, url, auth = false, base = false) {
		return this.init(ms, base, url, auth).pipe(
			first(),
			concatMap((v) =>
				this.http.delete(v.request_url, { headers: v.headers }).pipe(
					first(),
					catchError((e) => this.handleError(e)),
				),
			),
		);
	}

	private init(ms, base, url, auth, param = null) {
		let res: any = {
			headers: this.headers,
		};

		if (!base) url = `api/${environment.ms[ms]}/${url}`;

		if (environment.docker) {
			res.request_url = environment.docker_api_url[ms] + url;
		} else {
			res.request_url = environment.api_url + url;
		}

		if (param) {
			res.request_url += '&' + param;
		}

		// if (auth) {
		//   let token = this.appService.getLocal('l7_token');
		//   res.headers = res.headers.set('Authorization', `Bearer ${token}`);
		// }

		return of(res);
	}

	private handleError(e: HttpErrorResponse) {
		// this.appService.hasError(e, 'l7');
		return throwError(() => e);
	}
}
